export default __webpack_public_path__ + "static/media/francine.176c7a4e.jpg";